export const es = {
  // Navigation (Spanish)
  explore: 'Explorar',
  search: 'Buscar',
  create: 'Crear Publicación',
  messages: 'Mensajes',
  notifications: 'Notificaciones',
  settings: 'Configuración',
  profile: 'Perfil',
  logout: 'Cerrar Sesión',
  home: 'Inicio',
  
  // Authentication
  signin: 'Iniciar Sesión',
  signup: 'Registrarse',
  login: 'Iniciar Sesión',
  register: 'Registrarse',
  email: 'Correo Electrónico',
  password: 'Contraseña',
  confirmPassword: 'Confirmar Contraseña',
  firstName: 'Nombre',
  lastName: 'Apellido',
  forgotPassword: '¿Olvidaste tu contraseña?',
  alreadyHaveAccount: '¿Ya tienes cuenta? Inicia sesión',
  dontHaveAccount: '¿No tienes cuenta? Regístrate',
  
  // Posts
  recent: 'Reciente',
  trending: 'Tendencia',
  popular: 'Popular',
  like: 'Me Gusta',
  likes: 'Me Gusta',
  comment: 'Comentar',
  comments: 'Comentarios',
  share: 'Compartir',
  delete: 'Eliminar',
  edit: 'Editar',
  post: 'Publicación',
  posts: 'Publicaciones',
  title: 'Título',
  content: 'Contenido',
  tags: 'Etiquetas',
  noBlogsFound: 'No se encontraron blogs. ¡Intenta buscar algo más o crea el primero!',
  
  // AI Assistant
  quickActions: 'Acciones Rápidas',
  writeCaption: 'ESCRIBIR SUBTÍTULO',
  suggestTopics: 'SUGERIR TEMAS',
  improveContent: 'MEJORAR CONTENIDO',
  creativeIdeas: 'IDEAS CREATIVAS',
  clearChat: 'LIMPIAR CHAT',
  aiWritingAssistant: 'Asistente de Escritura IA',
  poweredByGroq: 'Impulsado por GROQ AI',
  aiGreeting: '¡Hola! Soy tu asistente de escritura IA. Puedo ayudarte a crear contenido atractivo, escribir subtítulos, sugerir temas de publicaciones y mejorar tu escritura. ¿En qué te gustaría trabajar hoy?',
  askMeToHelp: 'Pídeme ayuda con contenido, subtítulos, temas o escritura...',
  aiThinking: 'IA está pensando...',
  
  // Chat & Messages
  chat: 'Chat',
  noConversationsYet: 'Sin conversaciones aún',
  ideafluxChat: 'Chat IdeaFlux',
  typeMessage: 'Escribe un mensaje...',
  sendMessage: 'Enviar Mensaje',
  connectingToChat: 'Conectando al chat...',
  
  // Notifications
  noNotificationsYet: 'Sin notificaciones aún.',
  markAllRead: 'Marcar Todo como Leído',
  clearAll: 'Limpiar Todo',
  
  // Settings
  accountSettings: 'Configuración de Cuenta',
  displayName: 'Nombre de Usuario',
  emailAddress: 'Dirección de Correo',
  languagePreference: 'Preferencia de Idioma',
  privacySecurity: 'Privacidad y Seguridad',
  notificationPreferences: 'Preferencias de Notificación',
  allowDirectMessages: 'Permitir Mensajes Directos',
  letOthersMessage: 'Permitir que otros usuarios te envíen mensajes privados',
  likesOnPosts: 'Me gusta en publicaciones',
  commentsOnPosts: 'Comentarios en publicaciones',
  newFollowers: 'Nuevos seguidores',
  mentions: 'Menciones',
  save: 'Guardar',
  deleteAccount: 'Eliminar Cuenta',
  
  // Notification descriptions
  getNotifiedWhenSomeone: 'Recibe notificaciones cuando alguien',
  likesYourPosts: 'le guste tus publicaciones',
  commentsOnYourPosts: 'comente en tus publicaciones',
  followsYou: 'te siga',
  mentionsYou: 'te mencione',
  chooseNotifications: 'Elige qué notificaciones quieres recibir',
  controlWhoInteracts: 'Controla quién puede interactuar contigo',
  manageAccountInfo: 'Gestiona la información y preferencias de tu cuenta',
  emailCannotBeChanged: 'El email no se puede cambiar por razones de seguridad',
  
  // Common
  loading: 'Cargando...',
  cancel: 'Cancelar',
  update: 'Actualizar',
  submit: 'Enviar',
  back: 'Atrás',
  next: 'Siguiente',
  previous: 'Anterior',
  online: 'En línea',
  offline: 'Desconectado',
  
  // Profile
  editProfile: 'EDITAR PERFIL',
  noBioYet: 'Sin biografía aún.',
  followers: 'Seguidores',
  following: 'Siguiendo',
  recentActivity: 'Actividad Reciente',
  noPostsYet: 'Sin publicaciones aún',
  shareFirstPost: '¡Comparte tu primera publicación!',
  bio: 'Biografía',
  dateOfBirth: 'Fecha de Nacimiento',
  follow: 'Seguir',
  unfollow: 'Dejar de seguir',
  
  // Search
  discover: 'Descubrir',
  findPeopleStories: 'Encuentra personas, historias e ideas que te importan',
  searchByName: 'Buscar por Nombre, Título o #Etiqueta...',
  searchResults: 'Resultados de Búsqueda',
  noResultsFound: 'No se encontraron resultados',
  peopleFound: 'Personas Encontradas',
  
  // Settings - Additional keys
  enterDisplayName: 'Ingresa tu nombre de usuario',
  saving: 'Guardando...',
  confirmDeleteAccount: '¿Estás seguro de que quieres eliminar tu cuenta? Esto no se puede deshacer.',
  accountDeletedSuccessfully: 'Cuenta eliminada exitosamente.',
  errorDeletingAccount: 'Error al eliminar la cuenta. Por favor intenta de nuevo.',
  settingsSavedSuccessfully: '¡Configuración guardada exitosamente!',
  failedToSaveSettings: 'Error al guardar la configuración. Por favor intenta de nuevo.',
  
  // Form component
  pleaseSignInToCreate: 'Por favor inicia sesión para crear una publicación.',
  titleRequired: 'El título es requerido para publicar una publicación.',
  contentRequired: 'El contenido de la historia es requerido para publicar una publicación.',
  contentTooShort: 'El contenido de la historia debe tener al menos 10 caracteres.',
  postUpdatedSuccessfully: '¡Publicación actualizada exitosamente!',
  postPublishedSuccessfully: '¡Publicación publicada exitosamente!',
  pleaseSignInToCreateBlogs: 'Por favor inicia sesión para crear tus propios blogs de IdeaFlux.',
  enterEngagingTitle: 'Ingresa un título atractivo...',
  story: 'Historia',
  writeYourMasterpiece: 'Escribe tu obra maestra...',
  addTags: 'Agregar etiquetas...',
  add: 'Agregar',
  publishPost: 'Publicar Publicación',
  
  // Post component
  linkCopiedToClipboard: '¡Enlace copiado al portapapeles! Contador de compartidos actualizado.',
  youAndOthers: 'Tú y {{count}} otros',
  unknownUser: 'Usuario Desconocido',
  noImage: 'Sin Imagen',
  deletePost: 'Eliminar Publicación',
  confirmDeletePost: '¿Estás seguro de que quieres eliminar esta publicación?',
};